export const API_CONFIG = {
    baseUrl: 'https://api.facha.dev',
    defaultHeaders: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
}; 